<div class="website-audit-overview">
  <!-- cards -->
  <div class="website-audit-cards">
    <div
      class="website-audit-card"
      *ngFor="let card of infoCards; let i = index"
      (click)="card.failed || card.progress < 100 ? null : goToTabIndex(i + 1)"
      [style.cursor]="card.failed || card.progress < 100 ? 'default' : ''"
    >
      <div class="website-audit-card-header">
        <h1>{{ card.title }}</h1>

        <div
          *ngIf="card.progress >= 0 && card.progress < 100 && !noData"
          class="progress-circle"
          [style.--p]="card.progress"
        >
          {{ card.progress }}%
        </div>
      </div>
      <div class="website-audit-card-content">
        <ng-container *ngIf="!card.failed">
          <h1>{{ card.value }}</h1>
          <span>/ 100</span>
        </ng-container>
        <ng-container *ngIf="card.failed">
          <h1>N/A</h1>
        </ng-container>
      </div>
      <div class="website-audit-label-container" *ngIf="!noData">
        <ng-container *ngIf="!card.failed">
          <span
            class="website-audit-label"
            [ngClass]="getImpactLevel(card.value, true)"
          >
            {{ getImpactLevel(card.value, false) }}
          </span>
          <p *ngIf="card.issues > 0">{{ card.issues }} issues</p>
        </ng-container>
        <ng-container *ngIf="card.failed">
          <span class="website-audit-label low_value">Failed</span>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    class="website-audit-critical-issues"
    *ngIf="topCriticalIssues?.length > 0 && !showLoader && !noData"
  >
    <div class="critical-issues-header">
      <h1>Top Critical Issues</h1>
      <p>Highest priority items requiring immediate attention</p>
    </div>
    <div class="critical-issues-content">
      <div
        class="critical-issues-content-item"
        *ngFor="let issue of topCriticalIssues"
      >
        <div class="critical-issues-content-icon-container">
          <div class="critical-issues-content-icon">
            <mat-icon>priority_high</mat-icon>
          </div>
        </div>
        <div class="critical-issues-content-text">
          <h1>
            {{ issue.title }}
            <span
              class="website-audit-label"
              [ngClass]="getImpactLevel(issue.score, true)"
              >{{ issue.severity }}</span
            >
          </h1>
          <p>{{ issue.description }}</p>

          <div class="critical-issues-content-text-bottom">
            <span class="critical-issues-content-text-bottom-label">
              Category:
              <span class="website-audit-label">{{ issue.category }}</span>
            </span>
            <!-- <span class="critical-issues-content-text-bottom-label">
              Impact: <span>{{ issue.impact }}</span>
            </span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="critical-issues-footer">
      <h1 (click)="goToTabIndex(1)">
        View All Issues
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967L20.5303 11.4697C20.8232 11.7626 20.8232 12.2374 20.5303 12.5303L14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303C13.1768 18.2374 13.1768 17.7626 13.4697 17.4697L18.1893 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H18.1893L13.4697 6.53033C13.1768 6.23744 13.1768 5.76256 13.4697 5.46967Z"
            fill="currentColor"
          />
        </svg>
      </h1>
    </div>
  </div>

  <div class="website-audit-loader" *ngIf="showLoader">
    <div class="website-audit-loader-image">
      <svg
        width="200"
        height="161"
        viewBox="0 0 200 161"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46 47.5L71.5 62.5L97.5 47.5V17L71.5 2L46 17V47.5Z"
          [style.stroke]="loaderPercentage > 10 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M18 96.5L43.5 111.5L69.5 96.5V66L43.5 51L18 66V96.5Z"
          [style.stroke]="loaderPercentage > 20 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M102 46.5L127.5 61.5L153.5 46.5V16L127.5 1L102 16V46.5Z"
          [style.stroke]="loaderPercentage > 30 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          [style.stroke]="loaderPercentage > 35 ? '#8680ff' : '#c9c6cc'"
          d="M75 95.5L100.5 110.5L126.5 95.5V65L100.5 50L75 65V95.5Z"
          stroke-width="1.5"
        />
        <path
          d="M102 144.5L127.5 159.5L153.5 144.5V114L127.5 99L102 114V144.5Z"
          [style.stroke]="loaderPercentage > 40 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M107 75L98 84.5L93.5 80"
          [style.stroke]="loaderPercentage > 50 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M131 95.5L156.5 110.5L182.5 95.5V65L156.5 50L131 65V95.5Z"
          [style.stroke]="loaderPercentage > 60 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M46 144.5L71.5 159.5L97.5 144.5V114L71.5 99L46 114V144.5Z"
          [style.stroke]="loaderPercentage > 70 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M1 137.818L14.8641 146L29 137.818V121.182L14.8641 113L1 121.182V137.818Z"
          [style.stroke]="loaderPercentage > 80 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <path
          d="M171 38.8182L184.864 47L199 38.8182V22.1818L184.864 14L171 22.1818V38.8182Z"
          [style.stroke]="loaderPercentage > 90 ? '#8680ff' : '#c9c6cc'"
          stroke-width="1.5"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4057_1956"
            x1="100.75"
            y1="50"
            x2="100.75"
            y2="110.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#635BFF" />
            <stop offset="1" stop-color="#ADB4FB" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="multi_lines_loading_text_container">
      <div class="multi_lines_loading_text">
        <p
          *ngFor="let message of loaderTexts; let i = index"
          [ngClass]="{
            active: i == loaderLineIndex,
            before: i < loaderLineIndex,
            after: i > loaderLineIndex,
          }"
        >
          {{ message | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="website-audit-loader" *ngIf="noData">
    <div class="website-audit-loader-image"></div>
    <div
      class="multi_lines_loading_text_container"
      style="background: transparent !important"
    >
      <div class="multi_lines_loading_text">
        <p style="position: static">
          You don't have any audits yet, click here to add one.
        </p>
        <div class="custom-buttons_container" style="margin: 0 !important">
          <button
            mat-raised-button
            type="button"
            style="margin: auto !important"
            (click)="addAudit()"
          >
            <mat-icon class="button-icon">add</mat-icon>
            <span> Create Audit </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Loader Overlay -->
<div class="loading-data-overlay" *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
